import type {MaybeRef} from "vue";
import type {Product} from "@apptus/esales-api";
import {useGtm} from "@gtm-support/vue-gtm";

import {computed, unref} from "vue";

export const useGaProduct = ({product}: {product: MaybeRef<Product>}) => {
	const gtm = useGtm();

	const sku = computed(() => unref(product).custom?.sku?.[0]?.label);
	const productId = computed(() => unref(product).custom?.id?.[0]?.label);

	const gaProduct = computed(() => ({
		item_id: sku.value,
		item_name: unref(product).title,
		item_unique_id: productId.value,
		...(unref(product).brand && {item_brand: unref(product).brand}),
		price: unref(product).sellingPrice.min,
		quantity: 1,
	}));

	function onSelect(): void {
		gtm?.trackEvent({
			event: "select_item",
			_clear: true,
			ecommerce: {
				items: [gaProduct.value],
			},
		});
	}

	return {gaProduct, onSelect};
};
